class SlideshowBanner extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('.banner__slide'));
    if (!this.slides.length) return;

    this.dots = Array.from(this.querySelectorAll('.banner__dot'));
    this.index = 0;
    this.count = this.slides.length;
    this.delay = (parseInt(this.dataset.speed, 10) || 0) * 1000;
    this.canAutoplay =
      this.dataset.autoplay === 'true' &&
      this.count > 1 &&
      !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (this.count > 1) {
      this.addEventListener('click', (event) => {
        const button = event.target.closest('button');
        if (!button) return;
        if (button.classList.contains('banner__arrow--next')) this.go(1);
        else if (button.classList.contains('banner__arrow--prev')) this.go(-1);
        else if (button.dataset.dot !== undefined) this.select(Number(button.dataset.dot));
        else return;
        this.restart();
      });

      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());
    }

    this.select(0);
    this.start();

    // Slide 2's art is prepared only once the page has settled, so it never
    // competes with the LCP image. After that every advance preps the next one.
    const idle = window.requestIdleCallback || ((fn) => setTimeout(fn, 1200));
    const prime = () => {
      this.primed = true;
      this.hydrate((this.index + 1) % this.count);
    };
    if (document.readyState === 'complete') idle(prime);
    else window.addEventListener('load', () => idle(prime), { once: true });
  }

  // Swap data-src/data-srcset in. Slides after the first ship without a real
  // src, because stacked absolute slides defeat loading="lazy".
  hydrate(n) {
    const slide = this.slides[n];
    if (!slide) return;
    slide.querySelectorAll('img[data-src], source[data-srcset]').forEach((el) => {
      if (el.dataset.srcset) {
        el.srcset = el.dataset.srcset;
        delete el.dataset.srcset;
      }
      if (el.dataset.src) {
        el.src = el.dataset.src;
        delete el.dataset.src;
      }
    });
  }

  select(i) {
    this.slides.forEach((slide, n) => {
      const active = n === i;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', active ? 'false' : 'true');
    });
    this.dots.forEach((dot, n) => dot.setAttribute('aria-current', n === i ? 'true' : 'false'));
    this.index = i;
    this.updateMedia();
  }

  go(direction) {
    this.select((this.index + direction + this.count) % this.count);
  }

  updateMedia() {
    this.hydrate(this.index);
    if (this.primed) this.hydrate((this.index + 1) % this.count);
    this.slides.forEach((slide, n) => {
      const active = n === this.index;
      slide.querySelectorAll('video').forEach((video) => {
        if (active && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          const played = video.play();
          if (played) played.catch(() => {});
        } else {
          video.pause();
        }
      });
      if (active) {
        slide.querySelectorAll('iframe[data-src]').forEach((iframe) => {
          if (!iframe.src) iframe.src = iframe.dataset.src;
        });
      }
    });
  }

  start() {
    if (this.canAutoplay && !this.timer) {
      this.timer = setInterval(() => this.go(1), this.delay);
    }
  }

  stop() {
    clearInterval(this.timer);
    this.timer = null;
  }

  restart() {
    this.stop();
    this.start();
  }

  disconnectedCallback() {
    this.stop();
  }
}
customElements.define('slideshow-banner', SlideshowBanner);
